function sanitizeRow(row) {
  const MAX = 32767;
  const cleaned = {};
  for (const [k, v] of Object.entries(row)) {
    if (typeof v === 'string' && v.length > MAX) {
      cleaned[k] = v.slice(0, MAX); // or v.slice(0, MAX - 3) + '...'
    } else {
      cleaned[k] = v;
    }
  }
  return cleaned;
}

function groupDataByImageAndWorkload(data) {
  // Group data by image and workload combination
  // This creates groups where rows with the same image and workload are grouped together
  const grouped = {};
  
  data.forEach((row, index) => {
    const image = row.image || '';
    const workload = row.workload_name || '';
    const key = `${image}|${workload}`;
    
    if (!grouped[key]) {
      grouped[key] = {
        image,
        workload,
        rows: [],
        startIndex: index
      };
    }
    grouped[key].rows.push(row);
  });
  
  return grouped;
}


async function createMergedCellsWorksheet(data, EXPORTED_COLS, EXPORTED_HEADERNAME) {
  const XLSX = await import('xlsx');
  const grouped = groupDataByImageAndWorkload(data);
  const safeData = data.map(sanitizeRow);
  const ws = XLSX.utils.json_to_sheet(safeData, {
    origin: 'A2',
    skipHeader: true,
    header: EXPORTED_COLS,
  });

  // Add headers
  XLSX.utils.sheet_add_aoa(ws, [EXPORTED_HEADERNAME], { origin: 'A1' });

  // Create merged cells for image and workload columns
  // This will merge cells vertically for rows that have the same image and workload
  const merges = [];
  let currentRow = 2; // Start from row 2 (after header)

  Object.values(grouped).forEach(group => {
    const groupSize = group.rows.length;

    if (groupSize > 1) {
      // Find column indices for image and workload columns
      const imageColIndex = EXPORTED_COLS.indexOf('image');
      const workloadColIndex = EXPORTED_COLS.indexOf('workload_name');

      // Merge cells for image column (Affected Image)
      if (imageColIndex !== -1 && group.image) {
        merges.push({
          s: { r: currentRow - 1, c: imageColIndex }, // Start row (0-indexed)
          e: { r: currentRow + groupSize - 2, c: imageColIndex } // End row (0-indexed)
        });
      }

      // Merge cells for workload column (Affected Workload)
      if (workloadColIndex !== -1 && group.workload) {
        merges.push({
          s: { r: currentRow - 1, c: workloadColIndex }, // Start row (0-indexed)
          e: { r: currentRow + groupSize - 2, c: workloadColIndex } // End row (0-indexed)
        });
      }
    }

    currentRow += groupSize;
  });

  // Apply merges to worksheet
  if (merges.length > 0) {
    ws['!merges'] = merges;
  }

  return ws;
}

async function exportPipeline(data, EXPORTED_COLS, EXPORTED_HEADERNAME, fileName) {
  const XLSX = await import('xlsx');
  console.log('data', data);
  const book = XLSX.utils.book_new();

  // Use the new merged cells worksheet
  const ws = await createMergedCellsWorksheet(data, EXPORTED_COLS, EXPORTED_HEADERNAME);

  XLSX.utils.book_append_sheet(book, ws, fileName);
  XLSX.writeFile(book, `${fileName}.xlsx`);
}

export { exportPipeline };
